import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ModelBase } from 'store/model-base';
import { buildHeaders, buildParams, XmStore } from 'core/services';
import { E911Address, E911AddressStatus, E911AddressValidation, E911SaveAddress } from './models';
import { ApiChannel } from 'core/constants';
import { StoreAction } from 'store/actions';

@Injectable()
export class E911Api {
    public static validAddress(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<E911AddressValidation> {
        return http.post('/e911/address/validate', params, { headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }) }).pipe(
            map((response: ApiResponse) => E911AddressValidation.create<E911AddressValidation>({
                enteredAddress: params.address,
                ...response
            })),
            catchError(() => of(E911AddressValidation.create<E911AddressValidation>({ enteredAddress: params.address })))
        );
    }

    public static getAddress(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<E911Address> {
        return http.get('/e911/address', { headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }), params: buildParams({ mdn: params.mdn }) }).pipe(
            map((address: E911Address) => E911Address.create<E911Address>(address))
        );
    }

    public static saveAddress(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<E911SaveAddress> {
        return http.post('/e911/address', params, { headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY }) }).pipe(
            map((response: E911SaveAddress) => E911SaveAddress.create<E911SaveAddress>({ ...response, ...params }))
        );
    }

    public static addressStatus(_xmStore: XmStore, http: HttpClient, params: ApiParams): Observable<E911AddressStatus> {
        return http.get(`/e911/address/polling?requestIdKey=${params.requestId}`, {
            headers: buildHeaders({ apiChannel: ApiChannel.SSM_GATEWAY })
        }).pipe(
            map((response: E911AddressStatus) => E911AddressStatus.create<E911AddressStatus>(response))
        );
    }
}

ModelBase.fetchMapping[StoreAction.GET_E911_ADDRESS_VALIDATION] = E911Api.validAddress;
ModelBase.fetchMapping[StoreAction.GET_E911_ADDRESS] = E911Api.getAddress;
ModelBase.persistMapping[StoreAction.POST_E911_ADDRESS] = E911Api.saveAddress;
ModelBase.fetchMapping[StoreAction.GET_E911_ADDRESS_STATUS] = E911Api.addressStatus;
